module.exports = __webpack_public_path__ + "apple-touch-icon-76x76.png?4ba18bff99dcaa05c38770e1af340977";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-touch-icon-76x76.png
// module id = 145
// module chunks = 0